/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Video_FailedInputs */

const en_us2_share_video_failed = /** @type {(inputs: Share_Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't make the video.`)
};

const pt_br2_share_video_failed = /** @type {(inputs: Share_Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não deu para gerar o vídeo.`)
};

const es_419_share_video_failed = /** @type {(inputs: Share_Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo generar el video.`)
};

const pt_pt2_share_video_failed = /** @type {(inputs: Share_Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível gerar o vídeo.`)
};

const fr_fr2_share_video_failed = /** @type {(inputs: Share_Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de créer la vidéo.`)
};

const de_de2_share_video_failed = /** @type {(inputs: Share_Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Video konnte nicht erstellt werden.`)
};

const it_it2_share_video_failed = /** @type {(inputs: Share_Video_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile creare il video.`)
};

/**
* | output |
* | --- |
* | "Couldn't make the video." |
*
* @param {Share_Video_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_video_failed = /** @type {((inputs?: Share_Video_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Video_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_video_failed(inputs)
	if (locale === "es-419") return es_419_share_video_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_share_video_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_share_video_failed(inputs)
	if (locale === "de-DE") return de_de2_share_video_failed(inputs)
	if (locale === "it-IT") return it_it2_share_video_failed(inputs)
	return en_us2_share_video_failed(inputs)
});
export { share_video_failed as "share.video_failed" }